import moment from 'moment-timezone';
import { LegFiJwtService } from '../../services/auth/legfi-jwt.service';
import Moment = moment.Moment;

/**
 * Represents a transaction found on a bank statement that AI could not match to the ledger.
 * These items can be dismissed (soft delete) or converted to actual transactions.
 */
export class BankReconciliationMissingItem {
    id: number;
    organizationId: number;
    bankReconciliationId: number;
    transactionDate: Moment;
    description: string;
    amount: number; // In cents, negative for debits/payments
    type: 'debit' | 'credit';
    category: string;
    createdAt: Moment;
    updatedAt: Moment;

    constructor(data: any) {
        this.id = data.id || null;
        this.organizationId = data.organizationId || null;
        this.bankReconciliationId = data.bankReconciliationId || null;
        this.description = data.description || '';
        this.amount = data.amount || 0;
        this.type = data.type || 'debit';
        this.category = data.category || null;

        const timezone = LegFiJwtService.getTimezone();
        if (data.transactionDate) {
            // Parse date-only strings directly in timezone
            if (data.transactionDate.length === 10) {
                this.transactionDate = moment.tz(data.transactionDate, 'YYYY-MM-DD', timezone);
            } else {
                this.transactionDate = moment.utc(data.transactionDate).tz(timezone);
            }
        }
        if (data.createdAt) {
            this.createdAt = moment.utc(data.createdAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
        if (data.updatedAt) {
            this.updatedAt = moment.utc(data.updatedAt, 'YYYY-MM-DD hh:mm:ss').tz(timezone);
        }
    }

    /**
     * Returns the absolute amount in dollars (for display purposes)
     */
    get amountDollars(): number {
        return Math.abs(this.amount) / 100;
    }

    /**
     * Returns true if this is a debit/payment (money out)
     */
    get isDebit(): boolean {
        return this.type === 'debit' || this.amount < 0;
    }

    /**
     * Returns true if this is a credit/deposit (money in)
     */
    get isCredit(): boolean {
        return this.type === 'credit' || this.amount > 0;
    }
}
